﻿import * as paths from '../utils/paths';

export default class ResourcesHandler {
    constructor(rootURL) {
        this.rootURL = rootURL;
        this.resources = {};
    }

    load() {
        let promises = [];
        promises.push(this._getMapResourcesLoader());
        promises.push(this._getMapUiResourcesLoader());
        return Promise.all(promises);
    }

    get(value) {
        if (this.resources[value]) {
            return this.resources[value];
        } else {
            return value;
        }
    }

    _getMapResourcesLoader() {
        return new Promise((resolve, reject) => {
            $.ajax({
                type: "GET",
                url: this.rootURL + paths.MAP_RESOURCES_URL,
                async: true,
                contentType: "application/json; charset=utf-8",
                success: (result) => {
                    this._addToResources(result);
                    resolve();
                },
                error: (e) => {
                    reject(e);
                }
            });
        });
    }

    _getMapUiResourcesLoader() {
        return new Promise((resolve, reject) => {
            $.ajax({
                type: "GET",
                url: this.rootURL + paths.MAP_UI_RESOURCES_URL,
                async: true,
                contentType: "application/json; charset=utf-8",
                success: (result) => {
                    this._addToResources(result);
                    resolve();
                },
                error: (e) => {
                    reject(e);
                }
            });
        });
    }

    _addToResources(locale) {
        if (locale != null) {
            let keys = Object.keys(locale);
            keys.forEach(key => {
                this.resources[key] = locale[key];
            });
        }
    }
}